import { CartContext } from './context/CartContext';
import { IoIosCart } from 'react-icons/io';
import React, { useContext, useEffect, useRef } from 'react';
import getSymbolFromCurrency from 'currency-symbol-map';
import '../styles/Cart.css';
import AppContext from './context/AppContext';
import { bool } from 'prop-types';
import { useNavigate } from 'react-router-dom';
import CartOverlay from './CartOverlay';

const Cart = ({ isMobile }) => {
    const cartRef = useRef(null);
    const { appContext } = useContext(AppContext);
    const appConfig = appContext.config.themeConfig;
    const {
        cartState,
        checkoutData,
        showCartOverlay,
        setShowCartOverlay,
    } = useContext(CartContext);
    const navigate = useNavigate();

    const handleSetShowCartOverLay = () => {
        if (isMobile) {
            navigate('/shoppingcart.asp');
            setShowCartOverlay(false);
        } else {
            setShowCartOverlay((prev) => !prev);
        }
    };

    useEffect(() => {
        if (isMobile && showCartOverlay) {
            setShowCartOverlay(false);
        }
    }, [isMobile, setShowCartOverlay]);


    return (<div
        className={'cart-container'}>
        <button
            className={'cart-button'}
            ref={cartRef}
            aria-label={'Cart'}
            onClick={handleSetShowCartOverLay}>
            <IoIosCart
                className={'me-2'}
                size={'27px'}
            />
            <span
                className={'cart-counter'}>
                {cartState
                    ?.map((item) => item.quantity)
                    .reduce((prev, cur) => +prev + +cur, 0)
                    ?? 0}
            </span>
            {!isMobile && <div
                className={'cart-label d-flex flex-column'}>
                <p
                    style={{
                        whiteSpace: 'nowrap',
                    }}
                    className={'m-0 p-0'}>My Cart</p>
                <span
                    style={{
                        color: 'var(--primary-color)',
                    }}>
                    {getSymbolFromCurrency(appConfig.storeCurrency)}
                    {(checkoutData?.totalPrice ?? 0).toFixed(2)}
                </span>
            </div>}
        </button>
        <CartOverlay
            cartButtonRef={cartRef} />
    </div>);
};

Cart.propTypes = {
    isMobile: bool
};

export default Cart;